<style lang="scss" scoped>
.btn--floating {
  height: 56px;
  width: 56px;
  border-radius: 50%;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<template>
  <button
    @click="handleClick"
    :type="type"
    class="btn"
    :class="{ 'btn--floating': floating }"
    :disabled="workingState || disabled"
    ref="button"
    :style="style"
  >
    <span v-if="!workingState">
      <slot></slot>
    </span>
    <i v-if="workingState" class="fas fa-spinner fa-spin"></i>
  </button>
</template>

<script lang="babel">
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    working: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    floating: {
      required: false,
      type: Boolean,
      default: false
    },
    request: {
      type: Function,
      default: null,
      required: false,
      description: "request to send and toggle working state"
    },
    feedBackTimeMs: {
      type: Number,
      default: 1000,
      required: false,
      description: "set Time for spinner"
    },
  },
  data() {
    return {
      style: {
        width: ""
      },
      callingRequest: false
    };
  },
  computed: {
    workingState() {
      return this.working || this.callingRequest;
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
      if (this.request) {
        this.callingRequest = true;
        const spinTime = new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, this.feedBackTimeMs);
        });
        Promise.all([this.request(), spinTime]).finally(()=>{this.callingRequest = false;});
      }
    }
  },
  watch: {
    working(newValue) {
      if (newValue) {
        this.style.width = this.$refs.button.offsetWidth + "px";
      } else {
        this.style.width = "";
      }
    }
  }
};
</script>
